module.exports = __webpack_public_path__ + "static/media/navigate.6059c7f8.svg";